"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4328],{

/***/ 4328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Timeline_Timeline; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js
var withStyles = __webpack_require__(52543);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Timeline/TimelineContext.js
var TimelineContext = __webpack_require__(6597);
;// CONCATENATED MODULE: ./node_modules/@material-ui/lab/esm/Timeline/Timeline.js








var styles = function styles() {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '6px 16px',
      flexGrow: 1
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {},

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {},

    /* Styles applied to the root element if `align="alternate"`. */
    alignAlternate: {}
  };
};
var Timeline = /*#__PURE__*/react.forwardRef(function Timeline(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'left' : _props$align,
      classes = props.classes,
      className = props.className,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["align", "classes", "className"]);

  return /*#__PURE__*/react.createElement(TimelineContext/* default.Provider */.Z.Provider, {
    value: {
      align: align
    }
  }, /*#__PURE__*/react.createElement("ul", (0,esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, classes["align".concat((0,capitalize/* default */.Z)(align))], className),
    ref: ref
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var Timeline_Timeline = ((0,withStyles/* default */.Z)(styles, {
  name: 'MuiTimeline'
})(Timeline));
;// CONCATENATED MODULE: ./node_modules/@material-ui/lab/esm/Timeline/index.js


/***/ })

}]);